import { defineMessages } from 'react-intl';

export default defineMessages({
  imgTitle: {
    id: 'authenticator.onboarding.imageTitle',
    defaultMessage: 'After sales new generation',
  },
  imgDescription: {
    id: 'authenticator.onboarding.imageDescription',
    defaultMessage:
      'Digitalize your after-sales service to increase your customer satisfaction and reduce your operational costs.',
  },
  title: {
    id: 'authenticator.onboarding.entry.title',
    defaultMessage: 'Create your account',
  },
  lead: {
    id: 'authenticator.onboarding.entry.lead',
    defaultMessage:
      'Start with your company: we retrieve its address from the public registers, then its activity to prepare your configuration.',
  },
  homeLink: {
    id: 'authenticator.onboarding.entry.homeLink',
    defaultMessage: 'Revers.io website',
  },
});
